import { cs } from '../../../lib/currency';
import { useState } from 'react';
import { Loader2, DollarSign } from 'lucide-react';
import { Button } from '../../ui/button';
import api from '../../../services/api';
import { toast } from 'sonner';

/**
 * Backfill `amount` / `payment_amount` on every registration in this
 * tournament where the fee is missing or zero. Fixes the legacy "$0.00 in
 * payment reminder" bug for registrations created before v60. Idempotent.
 */
const RepairPaymentAmountsButton = ({ tournamentId, onRepaired }) => {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(
        `/tournaments/${tournamentId}/registrations/repair-payment-amounts`,
      );
      const repaired = data?.registrations_repaired || 0;
      const fee = data?.fee_applied;
      if (repaired > 0) {
        toast.success(
          `Backfilled ${cs()}${fee} on ${repaired} registration${repaired === 1 ? '' : 's'}.`,
        );
        onRepaired?.();
      } else if (data?.message) {
        toast.info(data.message);
      } else {
        toast.info('Nothing to repair — all registrations already have an amount.');
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to repair payment amounts');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      className="text-emerald-700 border-emerald-300 hover:bg-emerald-50"
      onClick={handleClick}
      disabled={busy}
      title="Backfill missing/$0 amounts on existing registrations using the tournament fee. Fixes the '$0.00 in payment reminder' bug for legacy rows. Idempotent."
      data-testid="repair-payment-amounts-btn"
    >
      {busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <DollarSign className="h-4 w-4 mr-1" />}
      Repair amounts
    </Button>
  );
};

export default RepairPaymentAmountsButton;
